import { FormikHelpers } from 'formik'
import React from 'react'

import { authService } from './auth-service'

export const useConfirmRegister = () => {
  const [isResending, setIsResending] = React.useState(false)

  const handleConfirmRegister = async (
    email: string,
    confirmationCode: string,
    {
      setSubmitting,
      setStatus,
      onSuccess,
    }: Partial<FormikHelpers<{ email: string; confirmationCode: string }>> & {
      onSuccess?: () => void
    },
  ) => {
    try {
      await authService.confirmRegistration(email, confirmationCode)

      onSuccess?.()

      // Navigation is now handled in the confirm email screen after automatic login
      // No automatic redirect here
    } catch (error: any) {
      authService.handleError(error, 'confirm', setStatus)
    } finally {
      setSubmitting?.(false)
    }
  }

  return {
    handleConfirmRegister,
    handleResendCode: async (email: string) => {
      try {
        setIsResending(true)
        await authService.resendEmailVerification(email)
      } catch (error: any) {
        authService.handleError(error, 'general')
      } finally {
        setIsResending(false)
      }
    },
    isResending,
  }
}
